export default __webpack_public_path__ + "static/media/arrows-manager-02.0bb4f802.svg";